import { transactionApi } from "../../config/axiosConfig";
import { QR_MANUAL_CHECK } from '../constants/transaction'
import { message } from 'antd';

const getQrManualCheck = (trxId, userId) => async dispatch => {
    dispatch({
            type: QR_MANUAL_CHECK.LOADING,
            payLoad: true
        })

    try{
        let apiCall = await transactionApi.get(`transaction/qr-truemoney-check/${trxId}/${userId}`)
        if(apiCall.status == 200){
            dispatch({
                    type: QR_MANUAL_CHECK.SUCCESS,
                    payLoad: apiCall.data.data
            })
            // if(apiCall.data.data.message){ 
            //     message.success(apiCall.data.data.message, 3)
            //     dispatch({
            //         type: QR_MANUAL_CHECK.SUCCESS,
            //         payLoad: apiCall.data.data.message
            // })
            // }
        }
                
    }catch(error){
        dispatch({
                type: QR_MANUAL_CHECK.ERROR,
                payLoad: error.response ? error.response.data.error : 'some thing went wrong'
            })
    }

}


export default getQrManualCheck